
import { Container, Row, Col, Nav } from "react-bootstrap";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import masterClassImg from '../assets/img/masterClassImg.jpg';
import advanceDesignGifImg from '../assets/img/advanceGifImg.gif';
import atp23Img from '../assets/img/atp23.jpg';
import atp24Img from '../assets/img/atp24.jpg';
import atp24bImg from '../assets/img/atp24b.jpg';

import atp25Img from '../assets/img/atp25.jpg';
import atp26Img from '../assets/img/atp26.jpg';
import atp27Img from '../assets/img/atp27.jpg';

export const GraphicsTrainingAdvance = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1>30 Days Master Class <span className='quoteHeader'>Graphics Design 201</span> Advance Training.</h1>
                <h4>Totlesoft Graphic Academy (TGA)</h4><br />
                <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={masterClassImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Special Offer Currently Open. <span className="chris">90% Off - Ending Soon!</span> see details at section J and act now!</h3><br />
                  
                  <p>Learning a skill has now become way easier with this one and only Online course that provides you with the needed environment, materials, and mentorship you need to not just learn one of the most profitable skills, but also ensures you master and make money from it.</p>
                  <p>Before you miss out on this once in a lifetime opportunity so many graphic designers have enjoyed, hear me out.</p>
                  <p>Totlesoft Graphic Academy (TGA) is the most resourceful graphic design online course that helps you learn effectively in no time the theories, practical and best practice in graphic design that can turn you into a professional in 30 days or less.</p>
                  
                  <h3>A. What will I benefit from this training?</h3><br />
                  <p>If you learn and practise all you would be taught in this 30 days course, you would be able to do the following without stress or any wasting of time.</p>
                  <p>💡 Understand the fundamentals and principles of graphic design. You would be able to know how to use the elements of design effectively.</p>
                  <p>💡 You will learn the secret on how to get *the best resources for your design projects.* </p>
                  <p>💡 How to come up with *creative ideas for your designs.* </p>
                  <p>💡 How to design with your *laptop using Photoshop and CorelDraw.*</p>
                  <p>💡 How to design with your *smartphone using Canva and Pixellab.*</p>
                  <p>💡 How to design *Logos, Flyers, Business Cards, Mockups, 3D logos, etc, using your Laptop or Smartphone.* </p>
                  <p>💡 *How to make money* from your skill as a graphic designer.</p>
                  <p>💡 How to become *more productive and do more with less time and effort.* </p>
                  <p>💡 How to grow a *profitable personal brand* as a graphic designer.</p>
                  <p>💡 *Top skills you need to know as a graphic designer* such as (Social Media, Content Creation, Freelancing, Sales, Marketing, etc)</p><br />

                  <h3>B. Why should I choose your course over others?</h3><br />
                  <p>You may have tried to learn graphic design online before in the past and it didn’t turn out well… It's not your fault.</p>
                  <p>That’s because all other graphic design courses are more concerned about teaching you how to use the latest design Software or Apps without ensuring you go through the required process and steps to start from the very beginning and walk you through to the top.</p>
                  <p>The Totlesoft Graphic Academy (TGA) you are about to be a part of is not the same. This is totally different.</p>
                  <p>This course is all about you and how you can succeed as a graphic designer.</p><br />

                  <h3>C. What is included in this package?:</h3><br />
                  <p>💡 24 practical assignments</p>
                  <p>💡 10 WhatsApp Sessions </p>
                  <p>💡 3 Live Sessions</p>
                  <p>💡 30K+ Design Resources</p>
                  <p>💡 Creativity Books on Graphic Design</p>
                  <p>💡 Certificate of Completion</p>
                  <p>💡 2 Month Mentorship</p>
                  <p>And a lot more</p>

                  <h3>D. What design tools are we using?</h3><br />
                  <p>The course is a 2 in 1 class</p>
                  <p>For those who own a laptop, and want to learn using it, you would learn how to design using Photoshop and CorelDraw</p>
                  <p>For those who own a smartphone, and want to learn using it, you would learn how to design using Pixellab and Canva</p><br />

                  <h3>E. How do I know this is real?</h3>
                  <p>We have successfully taught 2230+ students in this Academy, and over 8,000 students in other courses both paid and free</p>
                  <p>In Totlesoft Graphic Academy, you will learn the exact systems, formulas, and procedures you can use in becoming a voice in the design industry.</p>
                  <p>There are three faculties in Totlesoft Graphic Academy you would go through</p>
                  <p>🔰 Faculty of Personal Development</p>
                  <p>🔰 Faculty of Creativity </p>
                  <p>🔰 Faculty of Business</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={advanceDesignGifImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h3>F. Why Should I Join This Course Now</h3><br />
                  <p>You should join this course now because this singular action is about to change your life and finances forever by ensuring you learn a very profitable skill. </p>
                  <p>NOTE: There are limited slots.</p>
                  <p>Only those who get into this current batch early would get a great deal.</p>
                  <p>Most people would be left out. But I pray you won't. So, I urge you to get it right now…</p><br />

                  <h3>G. Package Bonus</h3><br />
                  <p>Only those who register within the time limit would get the following as bonuses:</p>
                  <p>🔰 Bonus 1: Typography Manual</p>
                  <p>🔰 Bonus 2: Color Theory Guide</p>
                  <p>🔰 Bonus 3: Introduction to Graphic Design</p>
                  <p>🔰 Bonus 4: Monetization Toolkit</p>
                  <p>🔰 Bonus 5: 20K+ Graphic Design Resources</p>
                  <p>🔰 Bonus 6: 10 Must-Read Books For all Creative Minds</p>
                  <p>🔰 Bonus 7: Upwork and Fiverr Account Opening Guides</p>
                  <p>🔰 Bonus 8: WhatsApp Automation Hacks</p>
                  <p>This academy is so loaded and impactful to the extent we could charge you N50,000 to register for it. But we won't 😊</p>
                  <p>The registration fee is N30,000.</p>
                  <p>We are offering you an opportunity to liberate yourself and become financially free</p>
                  <p>Relax! You would not be paying N50,000 because you came at this time of our discount offers.</p>
                  <p>The Early bird's fee is N20,000</p>
                  <p>But...</p>
                  <p>We want to allow 100 people to register for this batch of TGA with just N5000 between the time stated in the offer ad.</p>
                  <p>After the offer time elapse, the price increases to N20,000 and you will lose out of all the bonuses.</p>
                  <p> If I was you I would not wait till then. I would register now!</p>
                  <p>I once took advantage of an opportunity like this, and it has paid me more than I could have ever imagined.</p><br />

                  <h3>H. Why should I trust you and what if I don’t get all you promised?</h3><br />
                  <p>With almost a decade of experience in graphic design, we have seen and made lots of mistakes in this career path, and these mistakes are what we do not want you to make.</p>
                  <p>If at the end of 30 days of teaching and practice, you don't get all we promised and many more, be rest assured you will get a refund and an apology letter from us.</p><br />

                  <h3>I. Here is why you should register now</h3>
                  <p>💡 Only those who register early would gain access to all the bonuses listed above in this course.</p>
                  <p>💡 We have a special gift worth N20,000 for the first 20 persons who register for this course.</p>
                  <h5>See all you want to miss out of:</h5><br />
                  <p>1. 30 days graphic design class.</p>
                  <p>2. Download on-demand custom made practical graphic design videos.</p>
                  <p>3. Weekly theoretical and creative mind sessions.</p>
                  <p>4. 20,000+ Downloadable graphic design resources.</p>
                  <p>5. Full lifetime access to materials.</p>
                  <p>6. Course is available to both Smartphone and Laptop users.</p>
                  <p>7. Certificate of Completion.</p>
                  <p>8. 2-Months Mentorship</p>
                  <p>9. Opportunity to win N10,000 Cash Prize and lots of Gifts</p><br />

                  <h3 className="chris">J. Special Offer Currently Open for just this period:</h3><br />
                  <p>NOTE: Learning a skill such as graphic design demands lots of resources, time and even mony. Gain access to 3 of our BEST SELLING COURSES for less the price of one. This Courses Includes:</p>
                  <p>💡 Totlesoft Graphic Academy (TGA) Registration Fee (N25,000)</p>
                  <p>💡 Totlesoft Social Media Flyer Design (TSMFD) Master Class Registration Fee (N20,000).</p>
                  <p>💡 4 in 1 Totlesoft Pro Design Bundle (TPDB) Registration Fee (N15,000)</p>
                  <p>All these courses put together values at over N350,000</p>
                  <p>You can gain access to all 3 courses including a certificate of completion from Totlesoft Graphic Academy with just N5,000</p>
                  <p>And a lot more</p><br />

                  <Nav.Link href='/payment' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <h5 className="chris">Suported Currencies</h5>
                  <p>NGN, USD, GBP, GHS, KES, ZAR, TZS, UGX, XAF, XOF, RWF</p><br />
                  
                  <h5 className="chris">Payment Options</h5>
                  <p>Bank, Bank Transfer, Visa/Master Card, USSD</p><br />

                  <h5 className="chris">Crypto Currency & Payoneer</h5>
                  <p>Please contact us for directions: https://totlesoft/#connect</p><br />

                  <Nav.Link href='/payment' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <p>If after making the payment you did not hear from us in 2 hours, please send prove of payment to our WhatsApp so you can be added to the Student List.</p>
                  <p className="chris"><a href="https://wa.me/2348163913697">WhatsApp Link</a></p><br />

                  <h5>Act Now!</h5><br />

                  <h3>Note: <span className="chris">Latest Update from Totlesoft Marketing Team:</span></h3>
                  <h5>Please do well to fill in your correct information at the payment page</h5>
                  <p>Name: VERY IMPORTANT</p>
                  <p>Email: VERY IMPORTANT</p>
                  <p>Phone: OPTIONAL</p><br />

                  <h5>Also note that if after payment you were not automatically redirected to course access page, please check your email. A receipt will be sent to your email as shown below:</h5><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp23Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on it, it will open a message containing "Go to receipt" and Transaction Details as shown below:</h5><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp24Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on the "Go to receipt" button, it will first take you to a page as shown below:</h5><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp24bImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>And then automatically land you on the COURSE ACCESS PAGE/LINK TO JOIN THE SUPPORT GROUP.</h5><br /><br />
                  

                  <h3>Also, <span className="chris">Please leave a review to help others get this course</span></h3>
                  <h5>in the receipt email, you will find the "Transaction Detail" as show below:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp25Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on the link under the transaction detail, it will take you to a page as show below:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp26Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on the "Leave a Review" button, it will take you to a page where you can be able to leave a "A Review" on the course as shown below:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp27Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>Thanks in anticipation for leaving a positive review. God bless you.</h5><br />

                  <Nav.Link href='/payment' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <Nav.Link href='/academy' rel="noreferrer"><h3>Return to Academy Home Page</h3></Nav.Link><br />

                 
                 </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

